import { api } from "../../../utils/api";


export const deleteAccessGroup = async (data) => {

    try {
        var id = data;
        const response = await api.delete(`role/${id}`);
        return response.data;
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || error.response?.data?.error || "Erro inesperado.";
        throw new Error(errorMessage);
    }
};
